import {isPlatformServer} from "@angular/common";
import type {OnInit} from "@angular/core";
import {Component, DOCUMENT, inject, PLATFORM_ID} from "@angular/core";
import {Meta} from "@angular/platform-browser";
import {RouterOutlet} from "@angular/router";
import {WEB_APP_CONFIG} from "../common/app-config";
import {FooterComponent} from "./layout/footer/footer.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  imports: [
    FooterComponent,
    RouterOutlet,
  ],
})
export class AppComponent implements OnInit {
  private readonly description = $localize`IT-Services und Software - Wir sind Ihr kompetenter Partner, wenn es um die Entwicklung von kreativen mobilen Applikationen geht oder die Entwicklung von Individualsoftware.`;

  private readonly platformId = inject(PLATFORM_ID);
  private readonly webConfig = inject(WEB_APP_CONFIG);
  private readonly document = inject(DOCUMENT);
  private readonly meta = inject(Meta);

  public ngOnInit(): void {
    this.addMetaTags();
    this.addTrackingScript();
  }

  private addMetaTags(): void {
    this.meta.addTags([
      {
        name: "description",
        content: this.description,
      },
      {
        property: "og:description",
        content: this.description,
      },
    ]);
  }

  private addTrackingScript(): void {
    const trackingDomain = this.webConfig.trackingDomain;
    if (trackingDomain === undefined || trackingDomain.length === 0) return;
    const id = "sersoft-analytics";
    if (this.document.getElementById(id)) return;
    const script = this.document.createElement("script");
    script.id = id;
    script.type = "text/javascript";
    script.src = "https://analytics.sersoft.de/js/script.js";
    script.defer = true;
    if (isPlatformServer(this.platformId))
      script.setAttribute("data-domain", trackingDomain);
    else // This somehow fails on the server side
      script.dataset["domain"] = trackingDomain;
    this.document.body.appendChild(script);
  }
}
